import api from "./apiClient.js";

const endpoint = "communications";

export const getPossiblesCommunications = () => {
	return api.get(endpoint);
};

export const doActionMail = (data) => {
	return api.post(endpoint, data);
};
